import { Box, Button, Container, Flex, Icon, useToast, Text } from '@chakra-ui/react'
import { PageTransition } from '../../../components/PageTransition'
import { Link, useNavigate } from 'react-router-dom'
import { FiArrowLeft } from 'react-icons/fi'
import { HeaderSection } from '../HeaderSection'
import { ProdutoForm } from './components/ProdutoForm'
import { ObservacaoSection } from './components/ObservacaoSection'
import { QueryClientProvider, useQueryClient } from 'react-query'
import { useForm, FormProvider } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { pedidoSchema, formatQuantidadeParaCalculos } from './validationSchema'
import { api } from '../../../services/api'
import { adicionarPedidoAoCache } from '../PedidosEmAnalise/hooks/usePedidos'
import { useUser } from '../../../hooks/useUser'

export function CadastrarPedido() {
  const toast = useToast()
  const navigate = useNavigate()
  const queryClient = useQueryClient() // Obter a instância do queryClient
  const { codigo_usuario } = useUser() // Obtendo o código do usuário

  const defaultValues = {
    produto: '',
    produtoId: null,
    cor: '',
    corHex: '',
    gravacao: '',
    impressaoId: null,
    quantidade: '1000',
    valorUnitario: 0,
    observacao: '',
    logoFile: null,
    layoutFile: null,
    prazoProducao: 10,
  }

  const methods = useForm({
    resolver: zodResolver(pedidoSchema),
    defaultValues,
    mode: 'onChange',
  })

  const {
    handleSubmit,
    formState: { errors, isSubmitting, isValid },
  } = methods

  const subtotal = methods.watch('subTotal') || 0

  const onSubmit = async (data) => {
    try {
      const formData = new FormData()

      if (data.logoFile) {
        formData.append('logo', data.logoFile)
      }

      if (data.layoutFile) {
        formData.append('layout', data.layoutFile)
      }

      formData.append('codigo_usuario', codigo_usuario)

      formData.append('nome_produto', data.produto)
      formData.append('cor_produto', data.cor)
      formData.append('gravacao', data.gravacao)
      formData.append('id_impressao', data.impressaoId) // Adicionando o ID da impressão
      formData.append('quantidade', formatQuantidadeParaCalculos(data.quantidade))
      formData.append('valor_unitario', data.valorUnitario)
      formData.append('sub_total', data.subTotal)
      formData.append('observacao', data.observacao || '')
      formData.append('prazo_producao', data.prazoProducao || '10') // Usando o prazo calculado ou valor padrão
      formData.append('codigo_produto', data.codigoProduto)

      const response = await api.post('/site/v2/tercerizado/criar-pedido', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      console.log('Resposta da API:', response.data)

      adicionarPedidoAoCache(queryClient, {
        ...response.data,
        nome_produto: data.produto,
        cor_produto: data.cor,
        quantidade: formatQuantidadeParaCalculos(data.quantidade),
        valor_unitario: data.valorUnitario,
        sub_total: data.subTotal,
        prazo_producao: 10,
        data_entrada: new Date().toISOString(),
        status: 'Aguardando Aprovação',
      })

      toast({
        title: 'Pedido enviado com sucesso',
        description: 'Seu pedido foi enviado e está aguardando aprovação.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })

      navigate('/omnipromo/pedidos-em-analise?fromCadastro=true')
    } catch (error) {
      console.error('Erro ao enviar pedido:', error)

      toast({
        title: 'Erro ao enviar pedido',
        description: error.response?.data?.message || 'Ocorreu um erro ao tentar enviar seu pedido. Tente novamente mais tarde.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    }
  }

  return (
    <QueryClientProvider client={queryClient}>
      <FormProvider {...methods}>
        <PageTransition>
          <Box as="form" onSubmit={handleSubmit(onSubmit)} position="relative" zIndex={1} bg="white" minHeight="100vh">
            <HeaderSection title="ADICIONAR PEDIDO" />

            <Container maxW="1366px" px={2} py={8} position="relative" overflow="visible">
              <ProdutoForm subtotal={subtotal} />

              <Box mt={8} p={4} borderRadius="8px">
                <ObservacaoSection />
              </Box>

              <Flex justifyContent="center" mt={10} flexDirection="column" alignItems="center">
                {Object.keys(errors).length > 0 && (
                  <Text color="red.500" fontSize="14px" mb={4} textAlign="center">
                    Por favor, corrija os campos destacados antes de prosseguir.
                  </Text>
                )}

                <Button
                  type="submit"
                  bg="#378BBF"
                  color="white"
                  size="lg"
                  borderRadius="8px"
                  w="350px"
                  py={6}
                  _hover={{ bg: '#2A6990' }}
                  fontSize="14px"
                  isLoading={isSubmitting}
                  loadingText="Enviando..."
                >
                  Confirmar e Finalizar
                </Button>
              </Flex>

              <Flex mt={5} mb={10} justifyContent="center">
                <Button
                  leftIcon={<Icon as={FiArrowLeft} />}
                  variant="ghost"
                  as={Link}
                  to="/omnipromo"
                  color="#313E44"
                  fontWeight="normal"
                  fontSize="12px"
                >
                  cancelar e voltar
                </Button>
              </Flex>
            </Container>
          </Box>
        </PageTransition>
      </FormProvider>
    </QueryClientProvider>
  )
}
